import React, { useEffect, useRef } from 'react';

interface TradingViewWidgetProps {
  symbol: string;
}

const TradingViewWidget: React.FC<TradingViewWidgetProps> = ({ symbol }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    const containerId = `tv-widget-${symbol}`;
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/tv.js';
    script.async = true;
    script.onload = () => {
      if (!(window as any).TradingView) return;
      new (window as any).TradingView.widget({
        container_id: containerId,
        symbol: `BINANCE:${symbol}USDT`,
        interval: '60',
        timezone: 'Asia/Seoul',
        theme: 'light',
        style: '1',
        locale: 'kr',
        width: '100%',
        height: 400,
        hide_side_toolbar: false,
        allow_symbol_change: false,
        hide_top_toolbar: false,
      });
    };

    document.head.appendChild(script);
    scriptRef.current = script;

    return () => {
      if (scriptRef.current && document.head.contains(scriptRef.current)) {
        document.head.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
      if (container) container.innerHTML = '';
    };
  }, [symbol]);

  return (
    <div
      id={`tv-widget-${symbol}`}
      ref={containerRef}
      className="w-full rounded-xl overflow-hidden"
      style={{ minHeight: 400 }}
    />
  );
};

export default TradingViewWidget;
